<template>
	<div class="fund_manage">
		
		<!-- 表格  -->
		<a-table
		v-if="tableHeight>0"
			:loading="loading"
			:columns="columns"
			:dataSource="dataSource"
			:pagination="pagination"
			@change="onChangeload"
			:scroll="{ x: 1400, y: tableHeight }"
		>
			<div class="product_title" slot="product_title" slot-scope="text">
				<img :src="text.imgurl" class="table-imgurl" />
				<p>{{text.product_title}}</p>
			</div>
		
			<span slot="status" slot-scope="text">
				<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
				<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
				<a-tag v-else color="#969DA8">待上架</a-tag>
			</span>
			
			<span slot="flowing_num" slot-scope="text">
				<span v-if="text.type == '0'" style="color: #3C9D11;">+{{text.flowing_num}}</span>
				<span v-else-if="text.type == '1'" style="color: #FC5454">-{{text.flowing_num}}</span>
				<span v-else-if="text.type == '2'">{{text.flowing_num}}</span>
			</span>
		
			<span slot="action" slot-scope="text">
				<div style="margin-bottom: 6px;">
					<a-button icon="eye" size="small" @click="onSee(text.id)">库存详情</a-button>
				</div>
		
				<div>
					<a-button icon="plus" size="small">添加库存</a-button>
				</div>
			</span>
		</a-table>
		
	</div>
</template>

<script>
const columns = [
	{
		title: '序号',
		key: 'id',
		dataIndex: 'id',
		width: 85
	},
	{
		title: '商品名称',
		key: 'product_title',
		scopedSlots: { customRender: 'product_title' },
		width: 345
	},
	{
		title: '商品状态',
		key: 'status',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
		width: 120
	},
	{
		title: '规格',
		key: 'specifications',
		dataIndex: 'specifications',
		width: 200
	},
	{
		title: '供货价',
		key: 'price',
		dataIndex: 'price',
		width: 120
	},
	{
		title: '入库/出库',
		key: 'flowing_num',
		scopedSlots: { customRender: 'flowing_num' }
	},
	{
		title: '发生时间',
		key: 'add_date',
		dataIndex: 'add_date',
		width: 180
	},
	{
		title: '备注',
		key: 'content',
		dataIndex: 'content',
		width: 220
	},
];
export default {
	data() {
		return {
			activeKey: '1', //tabs默认选中的
			loading: true,
			columns,
			dataSource: [],
			visible: false,
			
			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 12 }
			},
			
			pagination: {
				page: 1,
				pagesize: 10,
				total: 0
			},
			tableHeight: 0
		};
	},
	mounted() {
		this.$nextTick(()=>{
			this.tableHeight = document.getElementsByClassName('fund_manage')[0].clientHeight-120;
		})
		this.axios()
	},
	methods: {
		// 搜索
		axios(){
			this.loading = true;
			
			let data = {
				id: this.$route.query.id,
				pid: this.$route.query.pid,
				...this.pagination
			};
			
			
			this.$request.post('?module=pc_api&action=product&app=stock_see', data).then(res => {
				let { code, message, data } = res;
				this.tableHeight = document.getElementsByClassName('fund_manage')[0].clientHeight-120;
				if (code === 200) {
					this.pagination.total = Number(res.data.total)
					this.dataSource = data.list
					
					setTimeout(() => {
						this.loading = false;
					}, 800);
				} else {
					this.$message.error(message);
					
					setTimeout(() => {
						this.loading = false;
					}, 800);
				}
			});
			
		},
		
		onChangeload(e){
			this.pagination.page = e.current
			this.axios()
		},
		
	}
};
</script>
<style lang="less" scoped>
	.derive {
		height: 200px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		> div {
			width: 100px;
			height: 100px;
			border: 1px solid #03a2f4;
			border-radius: 4px;
			color: #03a2f4;
			font-size: 14px;
			transition: background-color 0.5s;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-evenly;
			cursor: pointer;
		}
	
		> div:hover {
			border: 0px solid #03a2f4;
			color: #ffffff;
			background: #2890ff;
		}
	}
.fund_manage {
	height: 100%;
	
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	.difference {
		margin-right: 20px;
		.balance {
			font-size: 16px;
			color: #1e202c;
			margin-right: 20px;

			span {
				color: #03a2f4;
			}
		}
	}

	.table-imgurl {
		width: 60px;
		height: 60px;
	}
}

.reasonMask {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9999;

	> div {
		width: 460px;
		height: 278px;
		background: #ffffff;
		border-radius: 4px;

		.reasonMask_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;
			padding: 0 20px;
			box-sizing: border-box;
			border-bottom: 2px solid #e9ebef;
			font-size: 16px;
			font-weight: bold;
			color: #1e202c;
		}

		.reasonMask_content {
			display: flex;
			height: 149px;
			padding: 40px;
			font-size: 14px;
			color: #323543;

			&_left {
				width: 70px;
			}

			&_right {
				flex: 1;
				overflow: hidden auto;
			}
		}

		.reasonMask_bottom {
			height: 69px;
			border-top: 1px solid #e9ebef;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;

			div {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 112px;
				height: 36px;
				background: #03a1f3;
				border-radius: 2px;
				color: #ffffff;
				cursor: pointer;
			}
		}
	}
}

.product_title{
	display: flex;
	align-items: center;
	width: 310px;
	
	p{
		flex: 1;
		margin-left: 10px;
		margin-bottom: 0;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
}
</style>
